import { teamApi, Team } from "@/api/teams";
import { useQueryCache } from "@pinia/colada";
import { ensureQueryData } from "./utils";

export const TEAM_KEYS = {
    root: ["teams"] as const,
    list: () => [...TEAM_KEYS.root, "list"] as const,
};

export const teamsQueryOptions = {
    key: TEAM_KEYS.list(),
    query: () => teamApi.getTeams(),
    staleTime: 5 * 60_000,
};

export function readCachedTeams(): Team[] | undefined {
    return useQueryCache().getQueryData<Team[]>(TEAM_KEYS.list());
}

export async function ensureTeams(force = false): Promise<Team[] | undefined> {
    return await ensureQueryData<Team[]>(teamsQueryOptions, force);
}
